<template>
  <div class="container ethnicity">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="90" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip back="education"
      skip="householdincome">
    </back-and-skip>
    <div class="row pt-4 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/ethnicity.svg" alt="ethnicity">
      </div>
    </div>
    <div class="row pt-4 row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('ethnicity.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <div class="input-group mb-3">
          <input v-model="ethnicity.text"
            :placeholder="$t('ethnicity.selectOption')"
            v-on:click="showOptions"
            type="text"
            class="form-control input-select"
            readonly>
          <div class="input-group-append">
            <span class="input-group-text">></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <textarea v-model="info"
          :style="{visibility: showOther? 'visible' : 'hidden'}"
          class="w-100"
          rows="5"
          :placeholder="$t('ethnicity.specify')">
        </textarea>
      </div>
    </div>
    <div class="row pt-5 pb-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
    <modal name="options"
      :adaptive="true"
      :scrollable="true"
      :reset="true">
      <div class="container">
        <div class="row row-option">
          <div class="offset-10 col-2 text-right">
            <i @click="hideOptions" class="fas fa-chevron-down"></i>
          </div>
          <div class="col-12">
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-action pb-2"
                @click="selectOption(ethnicity)"
                v-for="ethnicity in ethnicities"
                :key="ethnicity.value">
                {{
                  ethnicity.text
                }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BackAndSkip from '../components/BackAndSkip.vue'

export default {
  data () {
    return {
      ethnicities: [
        { value: 'american-indian', text: this.$t('ethnicity.americanIndian') },
        { value: 'african', text: this.$t('ethnicity.african') },
        { value: 'white-caucasian', text: this.$t('ethnicity.caucasian') },
        { value: 'asian-pacific', text: this.$t('ethnicity.asian') },
        { value: 'hispanic', text: this.$t('ethnicity.hispanic') },
        { value: 'multiple-ethnicity', text: this.$t('ethnicity.multiple') }
      ],
      ethnicity: {
        text: '',
        value: ''
      },
      info: '',
      showOther: false
    }
  },
  components: {
    BackAndSkip
  },
  methods: {
    showOptions () {
      this.$modal.show('options')
    },
    hideOptions () {
      this.$modal.hide('options')
    },
    selectOption (option) {
      this.ethnicity = option
      this.$modal.hide('options')
    },
    next () {
      if (this.$v.$invalid) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.selectOptionError')
        })
      } else {
        if (this.ethnicity.value === 'multiple-ethnicity' && this.info === '') {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: this.$t('general.pleaseSpecifyError')
          })
          return
        } else if (this.ethnicity.value === 'multiple-ethnicity' && this.info !== '') {
          const answer = {
            key: 'info_race_ethnicity',
            value: this.info
          }

          this.$store.commit('SET_DATA_SURVEY', answer)
        }

        const answer = {
          key: 'race_ethnicity',
          value: this.ethnicity.value
        }

        this.$store.commit('SET_DATA_SURVEY', answer)

        this.$router.push({
          name: 'householdincome'
        })
      }
    }
  },
  watch: {
    ethnicity (val) {
      if (val.value === 'multiple-ethnicity') {
        this.showOther = true
      } else {
        this.showOther = false
      }
    }
  },
  validations: {
    ethnicity: {
      value: {
        required
      }
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'ethnicity')
  }
}
</script>

<style>
.ethnicity .img-question {
  width: 100%;
  height: 28vh;
}

.ethnicity .title {
  font-weight: 700;
  font-size: 1.3rem;
}

.ethnicity .col-select {
  border-radius: 10px;
  border: 1px solid #c1c1c1;
}

.ethnicity .input-select {
  border-right: none;
  border-color: #c1c1c1;
  color: #000;
}

.ethnicity .form-control:disabled, .form-control[readonly] {
  background-color: white !important;
}

.ethnicity *:focus {
  outline: none;
  box-shadow:none !important;
  border-color: #c1c1c1
}

.ethnicity .input-group-text {
  color: #c1c1c1;
  background-color: white;
  opacity: 1;
  border-color: #c1c1c1
}

.ethnicity .arrow {
  font: var(--unnamed-font-style-normal) normal normal 30px/35px Quicksand;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: center;
  font: normal normal normal 30px/35px Quicksand;
  color: #C1C1C1;
  opacity: 1;
}

.ethnicity textarea {
  resize: none;
  background-color: white;
  border-color: #c1c1c1;
  color: black;
}

.ethnicity input::placeholder {
  color: #C1C1C1;
}

.ethnicity textarea::placeholder {
  color: #c1c1c1;
}

.ethnicity .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

.ethnicity .row-option {
  overflow: auto;
}

.ethnicity .col-option {
  height: 5rem;
  font-size: 1.3rem;
  border-bottom: 1px solid #c1c1c1;
}

@media screen and (device-aspect-ratio: 40/71) {
  .ethnicity .img-question {
    width: 100%;
    height: 16vh;
  }

  .ethnicity .title {
    font-weight: 700;
    font-size: 1.3rem;
  }

  .ethnicity textarea {
    height: 4rem;
  }

  .ethnicity .next {
    min-height: 70px;
  }
}
</style>
